import { render, staticRenderFns } from "./blockEditor.vue?vue&type=template&id=6cb25d2f&"
import script from "./blockEditor.vue?vue&type=script&lang=js&"
export * from "./blockEditor.vue?vue&type=script&lang=js&"
import style0 from "./blockEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports